import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';
// import { TokenResponseDto } from '../../backend/model/tokenResponseDto';
import { UsersService } from '../../backend/api/users.service';
import { UserResponseDto } from '../../backend/model/userResponseDto';
import { UserRoleEnum } from '../../backend/model/userRoleEnum';
import { TokenResponseDto } from './../../backend/model/tokenResponseDto';

interface AuthLocalStorage {
  token: string;
  refreshToken: string;
}

interface DecodedToken {
  nameid: string;
  role: string;
  nbf: number;
  exp: number;
  iat: number;
}

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  tokensLocalStorageName = 'auth:tokens';
  userLocalStorageName = 'auth:user';
  helper = new JwtHelperService();
  // @ts-ignore
  onAuthChange: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(private usersService: UsersService) {}

  setAuth(response: TokenResponseDto) {
    const item = {
      token: response.accessToken,
      refreshToken: response.refreshToken,
    } as AuthLocalStorage;

    localStorage.setItem(this.tokensLocalStorageName, JSON.stringify(item));
    this.onAuthChange.next(true);
  }

  getAuth(): AuthLocalStorage | null {
    const item = localStorage.getItem(this.tokensLocalStorageName);
    return item ? (JSON.parse(item) as AuthLocalStorage) : null;
  }

  clearAuth() {
    localStorage.removeItem(this.tokensLocalStorageName);
    this.onAuthChange.next(true);
    this.clearUser(false);
  }

  isAuth(): boolean {
    return Boolean(this.getAuth());
  }

  getToken(): string | null {
    const auth = this.getAuth();
    return auth ? auth.token : null;
  }

  isTokenExpired(token: string): boolean {
    return this.helper.isTokenExpired(token);
  }

  decodeToken(): DecodedToken | null {
    const token = this.getToken();

    if (!token) {
      return null;
    }

    const decodedToken = this.helper.decodeToken(token);
    return decodedToken;
  }

  getUserRole(): UserRoleEnum | null {
    const role = this.decodeToken()?.role;
    return role ? (UserRoleEnum as any)[role] : null;
  }

  refreshMe() {
    this.usersService.apiUsersMeGet().subscribe(
      (res) => {
        this.setUser(res);
      },
      () => {
        this.clearUser();
      }
    );
  }

  setUser(user: UserResponseDto) {
    localStorage.setItem(this.userLocalStorageName, JSON.stringify(user));
    this.onAuthChange.next(true);
  }

  getUser(): UserResponseDto | null {
    const item = localStorage.getItem(this.userLocalStorageName);
    return item ? (JSON.parse(item) as UserResponseDto) : null;
  }

  clearUser(emitChange = true) {
    localStorage.removeItem(this.userLocalStorageName);

    if (emitChange) {
      this.onAuthChange.next(true);
    }
  }
}
